<template>
  <div class="vendor-charge-list tab-table p-2">
    <VendorChargesTable/>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import VendorChargesTable from "@/modules/vendor-charges/VendorChargesTable";

  const {mapState, mapActions} = createNamespacedHelpers('vendorCharges');
  const {mapState: mapStateCustomer} = createNamespacedHelpers('customer/customerView');

  export default {
    name: "VendorCharges",
    components: {VendorChargesTable},
    computed: {
      ...mapState({
        tableData: state => state.tableData[state.tableSource]
      }),
      ...mapStateCustomer({
        customer: state => state.customer
      })
    },
    methods: {
      ...mapActions(['updateTableSource', 'updateTableData', 'getTableData']),
    },
    async beforeMount() {
      await this.updateTableSource({
        source: 'customer',
        sourceUuid: this.customer.uuid
      });
    },
    mounted() {
      this.getTableData();
    }
  }
</script>

<style lang="scss" scoped>
</style>
